<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>

<div class="municipalities-container">
  @for (municipality of filteredMunicipalities; track municipality) {
    <div class="col-lg-4 col-md-6 municipality-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">{{ municipality.name }}</h5>
          </mat-card-title>
          <mat-card-subtitle>
            <p></p>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p>
            <strong>Email:</strong> {{ municipality.email }}
          </p>
          <p>
            <strong>Telefon:</strong> {{ municipality.telephone }}
          </p>
          <p>
            <strong>Mobitel:</strong> {{ municipality.mobile }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="primary" matTooltip="Uredite Općinu" (click)="goToEditMunicipality(municipality)">
            <mat-icon>edit</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>